import { useAuthStore } from "@/lib/api-functions/api-auth";
import { useNavigate } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/DefaultSelectDropdown";
import { useSimplifiedUserData } from "@/providers/SimplifiedUserDataProvider";
import { useTabContext } from "@/contexts/TabContext";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
export default function ProjectSelector() {
  const { t } = usePlatformTranslation();
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const { tabs, closeTab } = useTabContext();
  
  // Use the simplified user data provider
  const {
    games,
    selectedGame,
    selectGame,
    selectedCompany,
  } = useSimplifiedUserData();

  // Filter games by selected company
  const companyGames = selectedCompany 
    ? games.filter(game => game.company_id === selectedCompany.id)
    : games;

  if (!companyGames.length) {
    return null;
  }

  return (
    <div className="px-3 py-2 ">
      <Select
        value={selectedGame?.id || ""}
        onValueChange={(gameId) => {
          // Close all open tabs when switching games
          tabs.forEach(tab => {
            closeTab(tab.id);
          });
          
          // Set the selected game
          selectGame(gameId);
          
          // Navigate to the homepage for the newly selected game
          navigate('/home');
        }}
      >
        <SelectTrigger className="bg-transparent border-0 hover:bg-muted/50 transition-colors">
          <SelectValue placeholder={t('platform.ui.dropdowns.select_project')} />
        </SelectTrigger>
        <SelectContent>
          {companyGames.map((game) => (
            <SelectItem key={game.id} value={game.id}>
              {game.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
